<div class="dialog-content-min">
    <div class="card">
       <strong class="errormessage prerequisitestext">Prerequisites:</strong>
       <p class="errormessage margintop0">{{parentdata.message}}</p>
    <div class="file-upload-wrapper">
  <label class="upload-btn">
    Choose File
    <input type="file" (change)="onFileSelected($event)" />
  </label>

  <div class="file-name-box">
    {{ selectedFileName || 'No file chosen' }}
  </div>
</div>
       <div class="formgrid grid">
        <!-- <div class="field col-12">
          <input type="file" class="inputfile"class="form-control" (change)="onFileSelected($event)">
        </div> -->
    
        <div class="field col-12 sm:col-12 lg:col-12">
            <p-card *ngIf="errorList.length>0">
              <p-table [value]="errorList" [scrollable]="true" scrollDirection="horizontal" scrollHeight="250px" [rowHover]="true" tableStyleClass="error-table">
                <ng-template  pTemplate="caption" >
                  <div class="grid" class="errorhead">
                   <div class="col-12 lg:col-8 md:col-8 sm:col-12">
                    <span class=""><i class="pi pi-exclamation-triangle erroralerttext">&nbsp;Data Upload Error</i></span>
                   </div>
                    <div class="col-12 lg:col-4 md:col-4 sm:col-12 " >
                     <p-button label="Export Error Data" icon="pi pi-file-export" styleClass="exportexcel" pTooltip="Click to Download Error Data in Excel" tooltipPosition="bottom"
                     (click)="downloaderrorsheet()"/>
                    </div>
                  </div>
                
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                      <th class="redallerttext" *ngFor="let key of keys">  {{ key | titlecase }}
                      </th>
                  </tr>
                 </ng-template>
                 <ng-template pTemplate="body" let-rowData>
                  <tr >
                   <td  *ngFor="let key of keys;let i = index"
 [pTooltip]="rowData[key] ? rowData[key] : null"
                    tooltipPosition="left" 
                    [innerText]="rowData[key]"
                    [ngClass]="{'second-column': i === 1}">
                   </td>
                  </tr>
                </ng-template>
             </p-table>  
  
            </p-card>
          </div>
      </div>
</div>
</div>
<div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="closemodel()" ></p-button>
    <p-button class="m-1 w-full"   label="Upload" styleClass="customesave" (click)="fileuploadsave()" ></p-button>
 </div>

 